import { Card, Col } from 'reactstrap'
import { Headings } from '../../../../utils/Constant'
import { headingData } from '../../../../Data/Ui-Kits/Typography/Typography'
import HeadingsBody from './HeadingsBody'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const HeadingCart = () => {
  return (
    <Col xxl="6">
      <Card className="height-equal">
        <CommonCardHeader title={Headings} span={headingData} tagClass="mb-0" />
        <HeadingsBody />
      </Card>
    </Col>
  )
}

export default HeadingCart